import { User } from "@ideenherd";

export class UserViewModel {
    protected user: User;
    private _currentEventId: number
    get id(): number { return this.user.u_id; }
    get eventId(): number { return this.user.u_event_id; }
    get company(): string { return this.user.u_company; }
    get firstName(): string { return this.user.u_forename; }
    get lastName(): string { return this.user.u_surname; }
    get mobile(): string { return this.user.u_mobile; }
    get email(): string { return this.user.u_email; }
    get birthDay(): string { return this.user.u_birthday; }
    get licenceValid(): boolean {
        if (this.user.u_drivers_license === 1) {
            return true;
        } else {
            return false;
        }
    }
    get allowedToEvent(): boolean {
        let allowed: boolean;
        if (this.user.db_event.length > 0) {
            this.user.db_event.find(driver => {
                if (driver.e_id === this._currentEventId) {
                    allowed = true;
                }
                else {
                    allowed = false;
                }
            });
        } else {
            allowed = false;
        }
        return allowed;
    }
    get guestId(): number { return this.user.u_external_id; }
    get avatar(): [] { return this.user.u_avatar.data; }
    set currentEventId(id: number) { this._currentEventId = id; }
    constructor(userData: User) {
        this.user = userData;
    }

}